var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode-error-controller"},[_c('div',{staticClass:"round_top"},[_c('ul',{staticClass:"textedit"},[_c('li',{staticClass:"btn btn100 gray",on:{"click":_vm.changeError}},[_c('div',[_vm._v(_vm._s(_vm.errorText))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }